import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {Modal, Button, ControlLabel, Glyphicon} from "react-bootstrap";
import Select from "react-select";
import { STREAM_ORIGIN_TYPE } from "../../../constant/player";
import { createWidgetPlayer, getWidgetPlayerSettingsList } from "../../../../api/cp/widgetPlayer";

const DEFAULT_WIDGET_NAME = 'Новый виджет';

const EmbedCodeModal = ({show, episode, event, streamOriginType, onHide}) => {
    const {eventPassword} = useParams();
    const [widgetsList, setWidgetsList] = useState([]);;
    const [widgetKey, setWidgetKey] = useState(null);
    const isFlussonicOriginType = streamOriginType === STREAM_ORIGIN_TYPE.FLUSSONIC;
    const { moduleMain } = event || {};
    const isPlatform = moduleMain?.frontendPage === 'platform';

    useEffect(fetchWidgets, [event.eventKey]);

    async function fetchWidgets() {
        try {
            const response = await getWidgetPlayerSettingsList(event.eventKey);

            setWidgetsList(response.map(({widgetKey, name}) => ({
                value: widgetKey,
                label: !!name ? name : DEFAULT_WIDGET_NAME}),
            ));
            setWidgetKey(response?.[0]?.widgetKey);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleCreateWidget() {
        try {
            const response = await createWidgetPlayer(event.eventKey);
            setWidgetsList((prevState) => {
                return [
                    ...prevState,
                    {value: response.widgetKey, label: !!response.name ? response.name : DEFAULT_WIDGET_NAME},
                ];
            });
            setWidgetKey(response.widgetKey);
        } catch (error) {
            console.error(error);
        }
    }

    function createEmbedCode() {
        const watchKey = episode ? episode.key : event.eventKey;
        const src = isPlatform
            ?` https://${location.hostname}/widget/static/js/embed-player.js`
            : `https://${location.hostname}/player/js/embed.min.js`;

        return isPlatform
            ? `<script src="${src}" data-watchKey="${watchKey}"${!!widgetKey ? ` data-widgetKey="${widgetKey}"` : ''}></script>`
            : `<script src="${src}" data-eventKey="${watchKey}"></script>`;
    }

    return (
        <Modal show={show} onHide={onHide} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>Код встраивания</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {episode ?
                    <section>
                        <ControlLabel>Эпизод</ControlLabel>
                        <p>{episode.name_ru}</p>
                    </section>
                    :
                    <section>
                        <ControlLabel>Трансляция</ControlLabel>
                        <p>{event.name_ru}</p>
                    </section>
                }
                {isPlatform && (
                    !!widgetsList.length
                    ? <>
                        <ControlLabel>
                            Выбрать виджет для встраивания на страницу
                        </ControlLabel>
                        <Select
                            defaultValue={widgetsList.find((widget) => widget.value === widgetKey)}
                            options={widgetsList}
                            onChange={({ value }) => setWidgetKey(value)}
                        />
                        <p style={{marginTop: '12px'}}>
                            <i>
                                Настроить виджет можно
                                во вкладке <Link to={`/event/${eventPassword}/widgets/broadcast`}>Виджеты</Link>
                            </i>
                        </p>
                    </>
                    : <Button onClick={handleCreateWidget}>Добавить новый виджет</Button>
                )}
                <pre style={{ marginTop: '20px', whiteSpace: 'initial' }}>
                    <Button
                        style={{display: 'block', marginBottom: '12px'}}
                        onClick={() => navigator.clipboard.writeText(createEmbedCode())}
                    >
                        <Glyphicon glyph="copy" />
                    </Button>
                    {createEmbedCode()}
                </pre>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmbedCodeModal;
